import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Badge,
  CloseButton,
  InputGroup,
  Card,
  Row,
  Col,
} from "react-bootstrap";
import ProjectCodesServices, {
  getProjectCode,
  updateProjectCode,
} from "../../../../services/ProjectCodeService";
import { useParams, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditProjectCode = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: "",
    employeeId: "",
    projectCodes: [],
    id: "",
  });
  const [currentProjectCode, setCurrentProjectCode] = useState("");

  useEffect(() => {
    const fetchProjectCode = async () => {
      try {
        const projectCodeData = await ProjectCodesServices.view(id);
        setFormData({fullName: projectCodeData.data.fullName,
          employeeId: projectCodeData.data.employeeId,
          projectCodes: projectCodeData.data.projectCodes,
         id:projectCodeData.data._id});
      } catch (error) {
        console.error("Error fetching project code:", error);
      }
    };
    fetchProjectCode();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleProjectCodeChange = (e) => {
    setCurrentProjectCode(e.target.value);
  };

  const handleAddProjectCode = () => {
    if (currentProjectCode.trim() !== "") {
      setFormData((prevData) => ({
        ...prevData,
        projectCodes: [...prevData.projectCodes, currentProjectCode.trim()],
      }));
      setCurrentProjectCode("");
    }
  };

  const handleRemoveProjectCode = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      projectCodes: prevData.projectCodes.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await ProjectCodesServices.update(formData);
      toast.success("Project Code Update Successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // Closes after 3 seconds
      });
      // Delay navigation to ensure toast is visible
      setTimeout(() => {
        navigate("/settings/project-code");
      }, 3000);
      console.log("Project code updated successfully");
      // Replace with your desired route after update
    } catch (error) {
      console.error("Error updating project code:", error);
      toast.error("Failed to Update Project Code!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
      });
    }
  };

  return (
    <div>
      <Card>
        <h2>Edit Project Code</h2>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col>
              <Form.Group controlId="fullName">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Employee Name"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="employeeId">
                <Form.Label>Employee Id</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Employee Id"
                  name="employeeId"
                  value={formData.employeeId}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="projectCodes">
                <Form.Label>Project Codes</Form.Label>
                <InputGroup className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Enter Project Code"
                    value={currentProjectCode}
                    onChange={handleProjectCodeChange}
                  />
                  <Button
                    variant="outline-secondary"
                    onClick={handleAddProjectCode}
                  >
                    Add
                  </Button>
                </InputGroup>
                <div>
                  {formData.projectCodes.map((projectCode, index) => (
                    <Badge key={index} pill bg="secondary" className="me-2">
                      {projectCode}{" "}
                      <CloseButton
                        onClick={() => handleRemoveProjectCode(index)}
                      />
                    </Badge>
                  ))}
                </div>
              </Form.Group>
            </Col>
          </Row>
          <div className="d-flex justify-content-end mb-4">
            <Button variant="primary" type="submit">
              Update Project Code
            </Button>
          </div>
        </Form>
      </Card>
      {/* Toast Notification Container */}
      <ToastContainer />
    </div>
  );
};

export default EditProjectCode;
